import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class DashboardNumberChartFactory {
    /**
     * @console
     * @param {MediatorManager} mediatorManager 
     */
    constructor(mediatorManager) {
        this._mediatorManager = mediatorManager;
    }

    createNumberChart(container) {
        let numberChartMediator = this._mediatorManager.createMediator(container, SkinKeyRegistry.DASHBOARD_NUMBER_CHART_SKIN);
        return numberChartMediator;
    }
}